import axios from 'axios'


const kullanicilar = async (basvuruNo = null) => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/user/get',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            response = false
        });
    return response;
};

export default kullanicilar;